import { Html5Qrcode } from 'html5-qrcode';
import { createContext, PropsWithChildren, useEffect, useState } from 'react';

type TCameraContext = {
  camera: string | null;
};

export const CameraContext = createContext<TCameraContext>({
  camera: null,
});

export default function CameraProvider({ children }: PropsWithChildren) {
  const [camera, setCamera] = useState<string | null>(null);
  const getCameraDevice = () => {
    Html5Qrcode.getCameras().then((devices) => {
      try {
        if (devices.length > 0 && devices[0]?.id) {
          const cameraDevice = devices[0];
          setCamera(cameraDevice.id);
        } else {
          setCamera(null);
        }
      } catch {
        setCamera(null);
      }
    });
  };

  useEffect(() => {
    getCameraDevice();
    navigator.mediaDevices.addEventListener('devicechange', getCameraDevice);

    return () => {
      navigator.mediaDevices.removeEventListener(
        'devicechange',
        getCameraDevice,
      );
    };
  }, []);

  return (
    <CameraContext.Provider
      value={{
        camera,
      }}
    >
      <>{children}</>
    </CameraContext.Provider>
  );
}
